module.exports = __webpack_public_path__ + "img/html.3db31354.svg";